export const fields = {
    DEFAULT: {
        addressName: {
            show: true,
            required: true,
            maxLength: 35,
            allowedCharacters: /.*/
        },
        address1: {
            required: true
        },
        postalCode: {
            required: true
        },
        city: {
            required: true
        },
        region: {
            required: false
        },
        district: {
            reqired: false
        },
        phone: {
            show: true,
            required: true
        },
        email: {
            show: true,
            required: true
        },
        instructions: {
            show: false,
            required: false
        }
    },
    AR: {
        region: {
            required: true
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 45
        },
    },
    AT: {},
    AU: {
        region: {
            required: true
        },
        phone: {
            show: true,
            required: false
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 100
        }
    },
    BE: {},
    BN: {
        region: {
            required: true
        },
        email: {
            show: true,
            required: false
        }
    },
    CA: {
        region: {
            required: true
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 60
        }
    },
    CH: {},
    CL: {
        district: {
            required: true,
        },
        region: {
            required: true
        },
        postalCode: {
            required: false,
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 60
        }
    },
    CO: {
        region: {
            required: true
        },
        postalCode: {
            required: false
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 60
        }
    },
    CZ: {},
    DE: {},
    DK: {},
    ES: {},
    FI: {},
    FR: {},
    GB: {
        district: {
            required: true
        }
    },
    HK: {
        postalCode: {
            required: false
        }
    },
    HU: {},
    ID: {
        region: {
            required: true
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 60
        },
        email: {
            show: true,
            required: false
        }
    },
    IE: {},
    IL: {
        instructions: {
            show: true,
            required: false,
            maxLength: 50
        }
    },
    IS: {},
    IT: {},
    JP: {
        address1: {
            required: false
        },
        region: {
            required: true
        },
        district: {
            required: true
        },
        addressName: {
            show: true,
            required: true,
            maxLength: 35,
            allowedCharacters: /^([\u30A0-\u30FF]|[\u3000-\u303F]|[a-zA-Z0-9\\s\\.!\\\\/:@#&*-’, ]|[\u4E00-\u9FAF]|[\uFF00-\uFFEE]|[\u3040-\u309F]|\\s)*$/
        },
        email: {
            required: false
        },
        phone: {
            show: true,
            required: true,
            maxLength: 13
        }
    },
    LU: {},
    MX: {
        addressName: {
            show: true,
            required: true,
            maxLength: 30,
            allowedCharacters: /.*/
        },
        region: {
            required: true
        },
        district: {
            required: true
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 50
        },
    },
    MY: {
        region: {
            required: true
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 3
        },
        email: {
            show: true,
            required: false
        }
    },
    NC: {
        district: {
            required: true
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 100
        }
    },
    NL: {
        countryList: [
            { text: "Netherlands", value: "nl" },
            { text: "Austria", value: "at" },
            { text: "Belgium", value: "be" },
            { text: "Czech Republic", value: "cz" },
            { text: "Denmark", value: "dk" },
            { text: "Finland", value: "fi" },
            { text: "France", value: "fr" },
            { text: "Germany", value: "de" },
            { text: "Hungary", value: "hu" },
            { text: "Iceland", value: "is" },
            { text: "Ireland", value: "ie" },
            { text: "Italy", value: "it" },
            { text: "Luxembourg", value: "lu" },
            { text: "Norway", value: "no" },
            { text: "Poland", value: "pl" },
            { text: "Portugal", value: "pt" },
            { text: "Romania", value: "ro" },
            { text: "Spain", value: "es" },
            { text: "Slovakia", value: "sk" },
            { text: "Sweden", value: "se" },
            { text: "Switzerland", value: "ch" }
        ]
    },
    NO: {},
    NZ: {
        district: {
            required: true
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 100
        },
    },
    PE: {
        region: {
            required: true
        },
        district: {
            required: true
        },
        postalCode: {
            required: false
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 60
        },
        email: {
            show: false,
            required: false
        }
    },
    PF: {
        district: {
            required: true
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 100
        }
    },
    PH: {
        instructions: {
            show: true,
            required: false,
            maxLength: 60
        },
        email: {
            show: true,
            required: false
        }
    },
    PL: {},
    PT: {},
    RO: {},
    RU: {
        region: {
            required: true
        },
        phone: {
            show: true,
            required: false
        },
        email: {
            show: true,
            required: true,
            maxLength: 50
        }
    },
    SE: {},
    SG: {
        email: {
            show: true,
            required: false
        }
    },
    SK: {},
    TH: {
        instructions: {
            show: true,
            required: false,
            maxLength: 60
        },
        email: {
            show: true,
            required: false
        }
    },
    TR: {
        phone: {
            show: true,
            required: false
        },
        email: {
            show: true,
            required: true
        }
    },
    UA: {
        region: {
            required: true
        }
    },
    US: {
        region: {
            required: true
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 40
        },
        email: {
            show: true,
            required: true
        }
    },
    VN: {
        postalCode: {
            required: false
        },
        region: {
            required: true
        },
        district: {
            required: true
        },
        instructions: {
            show: true,
            required: false,
            maxLength: 100
        },
        email: {
            show: true,
            required: false
        }
    },
    ZA: {
        district: {
            required: true
        },
        region: {
            required: true
        }
    }
};
